<template>
    <div class="paymentResults" :class="{paymentResultsDark: isDark}">
        <div class="main">
            <div class="resultImg">
                <img :src="btnTitle[type].icon" alt="">
            </div>
            <div class="resultName">
                {{btnTitle[type].title}}
            </div>
            <!-- <div class="balance">当前嗨币余额：{{ balance }}</div> -->
            <div class="btnItem" @click="goToUrl(btnTitle[type].btnUrl)">{{btnTitle[type].btnTitle1}}</div>
            <div class="btnItem transparentBtn" @click="goToUrl(btnTitle[type].btnUrl2)">{{btnTitle[type].btnTitle2}}</div>
        </div>
    </div>
</template>

<script>
import { getCheckPayStatus } from "@/api/user"
import jsbridg from "@/utils/jsbridg"
export default {
    name: "paymentResults",
    props: ['type', 'balance', 'trade_no', 'paymentResultsShow'],
    data () {
        return {
            btnTitle: {
                recharge: {
                    title: '',
                    icon: '',
                    btnTitle1: '嗨币明细',
                    btnUrl: process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step10',
                    btnTitle2: '返回上一页',
                    btnUrl2: 'return'
                },
                model: {
                    title: '',
                    icon: '',
                    btnTitle1: '嗨币明细',
                    btnUrl: process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step10',
                    btnTitle2: '返回上一页',
                    btnUrl2: 'return'
                }
            }
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    watch: {
        paymentResultsShow (news) {
            if (news) {
                this.getCheckPayStatus()
            }
        }
    },
    methods: {
        goToUrl (url) {
            if (url === 'return') {
                jsbridg.goBack()
            } else {
                window.location.href = url
            }
        },
        async getCheckPayStatus () {
            const params = {
                trade_no: this.trade_no,
                sence: 'new'
            }
            const res = await getCheckPayStatus(params)
            if (res.errno * 1 === 2021) {
                this.btnTitle[this.type].icon = require("../../assets/img/user/paymentSuccessful.png")
                if (this.type === 'recharge') {
                    this.btnTitle[this.type].title = '充值成功'
                } else if (this.type === 'model') {
                    this.btnTitle[this.type].title = '支付成功'
                }
                // jsbridg.goBack()
            } else if (res.errno * 1 === 2008) {
                // 充值异常
                this.btnTitle[this.type].icon = require("../../assets/img/user/paymentFailed.png")
                if (this.type === 'recharge') {
                    this.btnTitle[this.type].title = '充值异常'
                } else if (this.type === 'model') {
                    this.btnTitle[this.type].title = '支付异常'
                }
            } else if (res.errno * 1 === 2009) {
                // 文章购买失败，嗨币已充值到您账户
                this.btnTitle[this.type].icon = require("../../assets/img/user/paymentFailed.png")
                this.btnTitle[this.type].title = '购买失败，嗨币已充值到您账户'
            } else if (res.errno * 1 === 2006) {
                // 微信支付的 但是微信支付走的是原生sdk 不清楚这个有什么用？？？
            } else {
                // 充值失败
                this.btnTitle[this.type].icon = require("../../assets/img/user/paymentFailed.png")
                if (this.type === 'recharge') {
                    this.btnTitle[this.type].title = '充值失败'
                } else if (this.type === 'model') {
                    this.btnTitle[this.type].title = '支付失败'
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.paymentResults{
    min-height: 100vh;
    background-color: #f5f5f5;
    .main{
        background-color: #fff;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 15px;
        padding-top: 65px;
        padding-bottom: 30px;
        .resultImg{
            img{
                width: 120px;
                height: 100px;
            }
        }
        .resultName{
            font-size: 17px;
            font-weight: 400;
            color: #333333;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .balance{
            font-size: 12px;
            font-weight: 400;
            color: #169AFF;
        }
        .btnItem{
            width: 100%;
            height: 44px;
            background: #169AFF;
            border-radius: 22px;
            font-size: 17px;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
        }
        .transparentBtn{
            border: 1px solid #999999;
            background: #fff;
            color: #999;
        }
    }
}
.paymentResultsDark{
    background: #232323;
    .main{
        background: #191919;
        .resultName{
            color: #d3d3d3;
        }
        .btnItem{
            color: #d3d3d3;
        }
        .transparentBtn{
            border-color: #232323;
            color: #a6a6a6;
        }
    }
}
</style>
